<template>
  <div class="files">
    <searchTag
      :type="type"
      :topic="topic"
      :job="job"
      :sex="sex"
      :showDiy="true"
      :cityId="city"
      :provinceId="province"
      ref="tag"
      @getList="getList"
      @getArea="getArea"
    />
    <div class="fileUp pt40">
      <div class="title f20 fw600 line28">文件上传</div>
      <div v-show="files.url" class="file active margint16 flex_r_between">
        <svgIcon v-show="type == 1" class="f64" name="file_video" />
        <svgIcon v-show="type == 2" class="f64" name="file_audio" />
        <svgIcon v-show="type == 3" class="f64" name="file_doc" />
        <div class="flex1 t_r marginl20">
          <div class="f18">100%</div>
          <div class="process"></div>
        </div>
        <div @click="delUrl" class="del f18 fgray marginl20">删除</div>
      </div>
      <div v-show="!files.url" class="file margint16 flex_r_center">
        <upFile @successCBK="getUrl" :token="token" />
      </div>
    </div>

    <div class="videoInfo f20 fw600 line28 pt40">档案信息</div>
    <div class="f16 line22 fw600 margint20">档案封面</div>
    <div class="margint8 f16 fgray cover flex_r">
      <el-upload
        class="avatar-uploader"
        :data="{ token: imgToken }"
        :action="action"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
      >
        <img v-if="files.fm" :src="files.fm" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div class="f16 line22 fw600 margint20">标题</div>
    <div class="margint8 fileTitle flex_r_between">
      <el-input
        type="text"
        placeholder="请输入视频标题"
        v-model="files.title"
        maxlength="20"
        show-word-limit
      >
      </el-input>
    </div>
    <div class="f16 line22 fw600 margint20">摘要/介绍</div>
    <div class="margint8 flex_c fileSummary">
      <el-input
        type="textarea"
        placeholder="请输入摘要"
        v-model="files.descp"
        maxlength="250"
        autosize
        show-word-limit
      >
      </el-input>
    </div>
    <div class="f16 line22 fw600 margint20">正文详情</div>
    <div class="margint8 fileContent flex_c">
      <div class="changeText">
        <div @click="changeText" class="flex_r action f16 line22">
          <svgIcon name="update" />
          <div class="marginl4">
            自动转换视频/音频为文字（免费{{ userInfo.free_xz }}/{{
              config.free_num
            }}）
          </div>
        </div>
        <div class="flex_r f16 line22 margint8 fgray flex_r">
          <svgIcon name="info" />
          <span class="marginl4"
            >该功能可以将您在上方上传的视频或者音频内容转为文字，帮助您快速填入文稿内容</span
          >
        </div>
      </div>
      <!-- <el-input
        type="textarea"
        placeholder="请输入正文内容"
        v-model="files.content"
        autosize
      >
      </el-input> -->
      <div class="content">
          <Tinymce ref="editor" v-model="files.content" :height="400" />
        </div>
    </div>
    <div class="f16 line22 fw600 pt40">相关图片</div>
    <div class="margint40 fgray">
      <div class="aboutWrap">
        <div class="aboutImg">+</div>
        <input accept="image/*" @change="getAboutImg" type="file" />
      </div>
      <div class="aboutList margint20">
        <div
          v-for="(item, index) in files.imgs"
          :key="index"
          class="item flex_r_between"
        >
          <img :src="item.url" alt="" />
          <div class="marginl16 flex1">
            <el-input
              type="text"
              placeholder="请输入内容"
              v-model="item.note"
              maxlength="30"
              show-word-limit
            ></el-input>
          </div>
          <div @click="delImgs(index)" class="f20 cursor del">删除图片</div>
        </div>
      </div>
      <!-- <el-upload
        class="upload-demo"
        :action="action"
        :data="{token}"
        :on-remove="handleRemove"
        :on-success="getImgs"
        :file-list="fileList"
        list-type="picture-card">
         <el-button size="small" class="aboutImg" type="primary">+</el-button>
      </el-upload> -->
    </div>
    <div @click="sub" class="sub f16">发布档案</div>
  </div>
</template>
<script>
import { getToken, qiNiuHost, up } from "@/assets/js/qiniu";
import searchTag from "../../components/searchTag.vue";
import upFile from "@/components/upFile";
import { mapActions, mapState } from "vuex";
let fileMap = new WeakMap();
export default {
  components: { searchTag, upFile },
  name: "files",
  data() {
    return {
      id: "",
      infoData: {},
      uid: "",
      type: 1,
      sex: 1,
      topic: 0,
      job: 0,
      province: 0,
      city: 0,
      tags: [],
      files: {
        url: "",
        fileName: "",
        fileType: "",
        fm: "",
        title: "",
        descp: "",
        content: "",
        imgs: [],
      },
      showFile: true,
      fileList: [],
      token: "",
      imgToken: '',
      action: "https://up.qbox.me",
    };
  },
  computed: {
    ...mapState(["userInfo", "config"]),
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getData(this.id);
    }
    getToken().then((res) => {
      this.token = res.uptoken;
    });
    this.$http(this.$api.getQiNiuCoverToken,{params:{}}).then((res)=>{
       this.imgToken = res.uptoken;
    })
    this.getUserInfo().then((res) => {
      this.uid = res.uid;
    });
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    async changeText() {
      let uid = this.$isLogin();
      if (!uid) return;
      let type = this.files.fileType;
      let url = this.files.url;
      //if( type != 'audio/mp3' || type != 'audio/mp4') return
      if( type == 'video/mp4' ){
        url = url.replace('mp4','mp3')
      }
      if (!url) return this.$alert("请先上传音频");
      if (this.userInfo.free_xz > 0) {
        //您确定要消耗一次免费语音识别吗
        this.$alert("您确定要消耗一次免费语音识别吗", {
          showClose: true,
          showCancelButton: true,
          callback: async (action, instance) => {
            if (action == "confirm") {
              let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              try{
                let data = await this.$http.get(this.$api.adudioToWord, {
                  params: {
                    url: url,
                    uid,
                  },
                });
                this.$set(this.files, "content", data.data);
                loading.close();
              }catch(e){
                loading.close();
                throw new Error(e)
              }
            }
          },
        });
      } else {
        //getCanAudio
        try {
          let data = await this.$http.get(this.$api.getCanAudio, {
            params: {
              uid,
            },
          });
          let loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let obj = await this.$http.get(this.$api.adudioToWord, {
            params: {
              url: this.files.url,
              uid,
            },
          });
          this.$set(this.files, "content", obj.data);
          loading.close();
        } catch (e) {
          loading.close();
          throw new Error(e)
        }
      }
    },
    delImgs(inx) {
      let imgs = this.files.imgs;
      imgs.splice(inx, 1);
      this.$set(this.files, "imgs", imgs);
    },
    getAboutImg(e) {
      let files = e.currentTarget.files[0];
      up(files, this.imgToken).then((res) => {
        let imgs = this.files.imgs;
        imgs.push({
          url:  qiNiuHost + res.key,
          note: "",
        });
        this.$set(this.files, "imgs", imgs);
      });
    },
    upQiniu(files) {
      if (files.length < 1) return;
      let file = files.unshift();
      up(this.token, file).then((res) => {
        console.log(res);
      });
      this.upQiniu(files);
    },
    getUrl(v) {
      this.files.url = v[0].url.indexOf('http')>-1?v[0].url.split(qiNiuHost)[1] : v[0].url;
      this.files.fileName = v[0].name;
      this.files.fileType = v[0].type;
    },
    delUrl() {
      this.files.url = "";
      this.files.fileName = "";
      this.files.fileType = "";
    },
    handleChange(file, fileList) {
      if (file) {
        this.showFile = false;
      }
      console.log(file);
    },
    handleAvatarSuccess(res, file) {
      this.files.fm = qiNiuHost + res.key;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    getImgs(res, file) {
      fileMap.set(file, qiNiuHost + res.key);
      let imgs = this.files.imgs;
      imgs.push(qiNiuHost + res.key);
      this.$set(this.files, "imgs", imgs);
    },
    handleRemove(file) {
      let key = fileMap.get(file);
      if (key) {
        let imgs = this.files.imgs;
        let inx = imgs.indexOf(key);
        if (inx > -1) {
          imgs.splice(inx, 1);
          fileMap.delete(key);
        }
      }
      return true;
    },
    handleDownload(file) {
      let url = file.url;
      this.onDownload(url);
    },
    async onDownload(url) {
      if (!this.$isLogin()) return;
      let aTag = document.createElement("a");
      aTag.href = url;
      aTag.download = true;
      aTag.style.display = "none";
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
    },
    async getList({ tagType, inx, input }) {
      this[tagType] = this.$refs.tag[tagType + "Arr"][inx].id;
      if (input) {
        this.tags = input.filter((item) => item != "") || [];
      }
    },
    getArea(obj) {
      this[obj.key] = obj.val;
    },
    async getData(id) {
      let uid = this.$getCookie('cy_uid');
      let { data } = await this.$http.get(this.$api.daInfo, {
        params: { id, uid: uid ? uid : "0" },
      });
      this.files = {
        url: data.url.indexOf('http') > -1 ? data.url.split(qiNiuHost)[1] : data.url,
        fileName: "",
        fileType: "",
        fm: data.fm_url,
        title: data.title,
        descp: data.descp,
        content: data.content,
        imgs: data.imgs,
      };
      this.sex = data.sex;
      this.topic = data.topic;
      this.job = data.job;
      this.type = data.type;
      this.tags = data.tags;
      this.city = data.city;
      this.province = data.province;
    },
    async sub() {
      if (!this.$isLogin()) return;
      if (!this.topic) return this.$message.error("请选择主题");
      if (!this.job) return this.$message.error("请选择职业");
      if (!this.province||!this.city) return this.$message.error("请选择地区");

      if (!this.files.url) return this.$message.error("请上传文件");
      //if (!this.files.fm) return this.$message.error("请上传封面");
      if (!this.files.title) return this.$message.error("请输入标题");
      if (!this.files.descp) return this.$message.error("请输入摘要");
      if (!this.files.content) return this.$message.error("请输入正文");
      let arr = [];
      this.files.imgs.forEach((item) => {
        arr.push(JSON.stringify(item));
      });
      this.$set(this.files, "imgs", arr);
      let data = await this.$http.post(this.$api.addDa, {
        id: this.id,
        tags: this.tags,
        topic: this.topic,
        type: this.type,
        job: this.job,
        sex: this.sex,
        city: this.city,
        province: this.province,
        uid: this.uid,
        ...this.files,
      });
      this.$router.replace({
        name: "info",
        params: {
          infoid: data.data,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.upload-demo {
  width: 1184px;
  flex-grow: 1;
  padding: 0 20px;
  box-sizing: border-box;
  flex-grow: 1;
  height: 100%;
}
.cover {
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  /deep/ .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.file {
  height: 140px;
  font-size: 30px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  &.active {
    padding: 0 40px;
  }
  .process {
    width: 100%;
    height: 8px;
    background: rgba(173, 39, 41, 1);
  }
  .del {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  button {
    width: 168px;
    height: 36px;
    font-size: 16px;
    color: white;
    text-align: center;
    cursor: pointer;
    line-height: 36px;
    background: #ad2729;
  }
}
.cover {
  width: 284px;
  border-radius: 4px;
  //border: 1px solid #e6e6e6;
}
.fileTitle {
  width: 1184px;
  height: 44px;
  border-radius: 4px;
  box-sizing: border-box;
  // border: 1px solid #958f8f;
}
.fileSummary {
  border-radius: 4px;
  box-sizing: border-box;
  align-items: stretch;
  /deep/ .el-textarea textarea {
    height: 80px !important;
  }
}
.fileContent {
  border-radius: 4px;
  align-items: stretch;
  box-sizing: border-box;
  /deep/ .el-textarea textarea {
    height: 200px !important;
  }
  .changeText {
    margin-bottom: 20px;
    .action {
      width: 340px;
      height: 36px;
      padding: 0 20px;
      line-height: 36px;
      cursor: pointer;
      color: white;
      background: #ad2729;
    }
  }
}
.aboutWrap {
  position: relative;
  width: 164px;
  height: 164px;
  cursor: pointer;
  input {
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    background: transparent;
  }
}
.aboutImg {
  width: 164px;
  height: 164px;
  cursor: pointer;
  line-height: 164px;
  text-align: center;
  background: #ffffff;
  font-size: 30px;
  color: gray;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
}
.aboutList {
  .item {
    margin-top: 20px;
    align-items: flex-start;
  }
  img {
    width: 164px;
    height: 124px;
    border-radius: 4px;
  }
  .del {
    margin-left: 60px;
  }
}
.sub {
  width: 104px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  color: white;
  margin-top: 60px;
  background: #ad2729;
}
</style>